import createVideoElement from './createVideoElement';

async function canPlayInBrowser(file: File): Promise<boolean> {
  const videoElement = createVideoElement();

  if (videoElement.canPlayType(file.type) === '') {
    return false;
  }

  const src = URL.createObjectURL(file);

  videoElement.src = src;

  try {
    await videoElement.play();
    videoElement.pause();
    URL.revokeObjectURL(src);
    return true;
  } catch (_e) {
    return false;
  }
}

export default canPlayInBrowser;
